// extracted by mini-css-extract-plugin
module.exports = {"cdcTocContainer":"CDC_cdcTocContainer__2Kgc0","emptyVersion":"CDC_emptyVersion__Diksg","unsupportedLink":"CDC_unsupportedLink__rkDUu"};